/**
 * Sentry init - error tracking + performance.
 *
 * Wolane raz w main.tsx PRZED ReactDOM.render. Brak DSN -> no-op
 * (dev/lokal bez SENTRY_DSN nie wysyla nic, OK).
 */
import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry(): void {
  if (!DSN) return;

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    // NIE propaguj sentry-trace do supabase.co (CORS fail - patrz adresflow v1 history)
    tracePropagationTargets: [/^https:\/\/api\.adresflow\.com/, "localhost"],
    ignoreErrors: [
      "ChunkLoadError",
      "Loading chunk",
      "Failed to fetch dynamically imported module",
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
    ],
  });
}
